let pos_comp_BillItemsSelectModal = require("../../templates/pos/comp/BillItemsSelectModal.handlebars");
let pos_comp_BillItemSelectList = require("../../templates/pos/comp/BillItemSelectList.handlebars");
let Backbone = require("backbone");
let _ = require("underscore");
let BasePagingModel = require("../../model/BasePagingModel.js");
import SwitchItemModalView from "../table/SwitchItemModalView.js";

let main = function () {
    return Backbone.View.extend({

        events: {
            "click .pageUp": "onPrev",
            "click .pageDown": "onNext",
            "click .billItemsListSelectList li": "onSelectItem",
            "click .confirm-switch": "confirmSwitch",
            "hidden.bs.modal": "onClose",
            'click .all-choose': "allChoose"
        },

        initialize: function (params) {
            console.log('table select view params', params);
            this.model = new BasePagingModel(params);
            this.model.set({pageSize: 20});
        },

        /**
         * Triggered when modal closing
         */
        onClose: function () {
            this.trigger("closeSelect");
        },

        onPrev: function () {
            this.model.prev();
            this.renderTableList();
        },

        onNext: function () {
            this.model.next();
            this.renderTableList();
        },

        onMouseOver: function (evt) {
            $(evt.target).addClass("selected");
        },

        onMouseOut: function (evt) {
            $(evt.target).removeClass("selected");
        },

        confirmSwitch: function () {
            var self = this;
            var itemsCollection = new Backbone.Collection();
            if (!this.switchItemModalView) {
                this.switchItemModalView = new SwitchItemModalView();
            }
            _.each(this.$(".billItemsListSelectList li"), function (li) {
                if ($(li).find(".status").hasClass("check")) {
                    itemsCollection.add(self.bill.getBillItems().get($(li).data("cid")))
                }
            });
            this.switchItemModalView.model = itemsCollection;
            this.switchItemModalView.table = this.table;
            this.switchItemModalView.bill = this.bill;
            this.switchItemModalView.render();
            this.listenToOnce(this.switchItemModalView, "closed", function () {
                self.$el.modal('hide');
            });
        },
        allChoose: function (evt) {
            var crtEvt = $(evt.currentTarget);
            if (crtEvt.find(".status").hasClass("check")) {
                this.$(".billItemsListSelectList li .status").removeClass("check");
            } else {
                this.$(".billItemsListSelectList li .status").addClass("check");
            }
            crtEvt.find(".status").toggleClass("check");
        },
        onSelectItem: function (evt) {
            var crtEvt = $(evt.currentTarget);
            if (crtEvt.hasClass("disabled")) {
                return false;
            }
            crtEvt.find(".status").toggleClass("check");
            this._checkChooseStatus();
        },
        _checkChooseStatus: function () {
            var allChoose = true;
            _.each(this.$(".billItemsListSelectList li"), function (li) {
                if (!$(li).find(".status").hasClass("check")) {
                    allChoose = false;
                }
            });
            if (allChoose) {
                this.$(".all-choose .status").addClass("check");
            } else {
                this.$(".all-choose .status").removeClass("check");
            }
        },

        render: function () {
            $('.billItemSelectListModal').remove();
            this.setElement(pos_comp_BillItemsSelectModal());
            this.renderBillItemList();
            this.$el.modal();
            return this;
        },

        renderBillItemList: function () {
            let items = [];
            this.model.each(function (item) {
                var jsonItem = item.toJSON();
                if (jsonItem.orderedQuantity > 0) {
                    jsonItem.cid = item.cid;
                    items.push(jsonItem);
                }
            });
            this.$(".listContainer").html(pos_comp_BillItemSelectList({
                billItemJson: items,
            }));
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/BillItemsSelectModalView.js